import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup
  .object({
    name: yup
      .string()
      .required('Name is required')
      .trim()
      .min(1, 'Name must be at least 1 character'),
    city: yup
      .string()
      .required('City is required')
      .trim()
      .min(1, 'City must be at least 1 character'),
  })
  .required()

const resEditAccount = yupResolver(schema)

export default resEditAccount
